export default __webpack_public_path__ + "static/media/2@2x.ef76c466.png";